import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMomenteoComponent } from './simple-icons-momenteo.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMomenteoComponent ],
    exports:      [ SimpleIconsMomenteoComponent ],
    bootstrap:    []
})
export class SimpleIconsMomenteoModule {}
